var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateSubscriberAddressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 23,
    viewBox: "0 0 16 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11158_7150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 1.90002C4.3509 1.90002 1.3999 4.90502 1.3999 8.62002C1.3999 13.66 7.9999 21.1 7.9999 21.1C7.9999 21.1 14.5999 13.66 14.5999 8.62002C14.5999 4.90502 11.6489 1.90002 7.9999 1.90002ZM7.9999 11.02C6.6989 11.02 5.6429 9.94502 5.6429 8.62002C5.6429 7.29602 6.6989 6.22002 7.9999 6.22002C9.3009 6.22002 10.3569 7.29602 10.3569 8.62002C10.3569 9.94502 9.3009 11.02 7.9999 11.02Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11158_7150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateSubscriberAddressIcon);
export default __webpack_public_path__ + "static/media/corporateSubscriberAddressIcon.ab069efb01e8e4c3f460c35da4954115.svg";
export { ForwardRef as ReactComponent };